import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { selectStoppageType } from 'reports/stoppagesPareto/selectors'

const StoppagesParetoReportGraphTooltip = ({ stoppageType, payload, ...rest }) => {
  if (!payload) {
    return null
  }

  const [duration, total] = payload

  if (!stoppageType || !duration || !total) {
    return null
  }

  return (
    <div className='report-graph-tooltip'>
      <div className='report-graph-tooltip__content'>
        <h4 className='report-graph-tooltip__header'>{stoppageType.symbol}</h4>
        <div>{stoppageType.description}</div>
      </div>

      <div className='report-graph-tooltip__footer'>
        {Math.round(duration.value)} min. / {Math.round(total.value * 1000) / 10.0} %
      </div>
    </div>
  )
}

StoppagesParetoReportGraphTooltip.propTypes = {
  label: PropTypes.number,
  payload: PropTypes.array,
  stoppageType: PropTypes.shape({
    symbol: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
  })
}

const mapStateToProps = (state, { label: stoppageTypeId }) => ({
  stoppageType: selectStoppageType(state, stoppageTypeId)
})

export default connect(mapStateToProps)(StoppagesParetoReportGraphTooltip)
